var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthyLifeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M46.2996 24.7266L34.189 12.616L22.0783 24.7266L34.189 36.8372L46.2996 24.7266Z",
    fill: "#EA0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6665 41.2109L46.6665 19.2109L33.4629 6.00732L24.6665 14.8037L15.8701 6.00732L2.6665 19.2109L24.6665 41.2109Z",
    stroke: "#EA0404",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyLifeHeart);
export default __webpack_public_path__ + "static/media/HealthyLifeHeart.fb21e8df5f5152cc005dcb1aab298c20.svg";
export { ForwardRef as ReactComponent };